const withErrorBoundary = require('utils/framework/hocs/withErrorBoundary/withErrorBoundary');


module.exports = withErrorBoundary;
